const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

/* ------------------------------------------------------------------
   CHG — default Glove Size to M/L instead of the first variant (S).
   Added 24 Sep 2026. Theme: chgfinal 1.2 only.
   First re-highlights the pills to match the variant the form will really
   add (fixes S showing while M was in the cart), then clicks the M/L pill on
   load, which runs the section's own handler and keeps price / availability /
   cart variant id in sync. Updated 27 Sep 2026.
   Skips entirely if the shopper arrived with ?variant= in the URL.
   TO REVERT: delete this block.
   ------------------------------------------------------------------ */
(function () {
  var done = false;
  var tries = 0;

  // The section picks a default variant server-side (e.g. size M) but highlights
  // the first value of each option (e.g. S). Re-highlight the pills so they show
  // the variant that will actually be added to the cart.
  function syncPillsToForm() {
    document.querySelectorAll('[id^="ChPdpVariantId-"]').forEach(function (input) {
      var sectionId = input.id.replace('ChPdpVariantId-', '');
      var dataEl = document.getElementById('ChPdpVariants-' + sectionId);
      var root = document.getElementById('shopify-section-' + sectionId);
      if (!dataEl || !root) return;
      var variants = [];
      try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
      var v = variants.filter(function (x) { return String(x.id) === String(input.value); })[0];
      if (!v) return;
      root.querySelectorAll('.ch-pdp-variant-options').forEach(function (group, i) {
        var want = v.options[i];
        var pills = group.querySelectorAll('.ch-pdp-variant-pill');
        var match = Array.prototype.filter.call(pills, function (p) { return p.getAttribute('data-value') === want; })[0];
        if (!match) return;
        Array.prototype.forEach.call(pills, function (p) { p.classList.toggle('is-selected', p === match); });
      });
    });
  }

  function apply() {
    if (done) return;
    tries++;

    try {
      if (new URLSearchParams(window.location.search).has('variant')) {
        done = true;
        return;
      }

      if (!document.querySelector('.ch-pdp-variant-pill')) {
        if (tries < 12) setTimeout(apply, 150);
        return;
      }

      syncPillsToForm();

      var target = document.querySelector('.ch-pdp-variant-pill[data-value="M/L"]');
      if (!target) {
        done = true;
        return;
      }

      var blocked =
        target.disabled ||
        target.classList.contains('disabled') ||
        target.classList.contains('is-disabled') ||
        target.classList.contains('is-unavailable') ||
        target.getAttribute('aria-disabled') === 'true';

      if (blocked || target.classList.contains('is-selected')) {
        done = true;
        return;
      }

      done = true;
      target.click();
    } catch (e) {
      done = true;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply);
  } else {
    apply();
  }
})();

/* ------------------------------------------------------------------
   CHG — PDP gallery fix. Added 27 Sep 2026. Theme: chgfinal 1.2.
   The PDP section passes each variant's *media* id to the gallery, but the
   gallery images are tagged with *image* ids, so choosing a variant (incl.
   the M/L default above) hid every photo. When the variant changes, this
   looks up the variant's image id and shows it; if there is none, it keeps
   (or restores) a visible photo so the gallery is never blank.
   ------------------------------------------------------------------ */
(function () {
  var productJson = null;

  function gallery() { return document.querySelector('.ch-pdp-gallery-main'); }

  function show(imageId) {
    var g = gallery();
    if (!g) return;
    var imgs = Array.prototype.slice.call(g.querySelectorAll('[data-image-id]'));
    if (!imgs.length) return;
    var target = imageId && g.querySelector('[data-image-id="' + imageId + '"]');
    if (!target) {
      if (g.querySelector('[data-image-id].is-active')) return;
      target = imgs[0];
    }
    var id = target.getAttribute('data-image-id');
    imgs.forEach(function (img) { img.classList.toggle('is-active', img === target); });
    document.querySelectorAll('.ch-pdp-thumb[data-image-id]').forEach(function (t) {
      t.classList.toggle('is-active', t.getAttribute('data-image-id') === id);
    });
  }

  function loadProduct() {
    if (productJson) return Promise.resolve(productJson);
    var m = window.location.pathname.match(/\/products\/([^\/?#]+)/);
    if (!m) return Promise.resolve(null);
    return fetch('/products/' + m[1] + '.js')
      .then(function (r) { return r.json(); })
      .then(function (p) { productJson = p; return p; })
      .catch(function () { return null; });
  }

  function onVariantChange(input) {
    var variantId = String(input.value);
    show(null);
    loadProduct().then(function (p) {
      if (!p) return;
      var v = (p.variants || []).filter(function (x) { return String(x.id) === variantId; })[0];
      show(v && v.featured_image ? String(v.featured_image.id) : null);
    });
  }

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.id && t.id.indexOf('ChPdpVariantId-') === 0) onVariantChange(t);
  });

  function safetyNet() { show(null); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', safetyNet);
  } else {
    safetyNet();
  }
})();

/* ------------------------------------------------------------------
   CHG — keep the header cart count in sync. Added 27 Sep 2026.
   The PDP / box builder add to cart with fetch('/cart/add.js') and never
   re-rendered the header bubble, so the count stayed stale until reload.
   This refreshes #cart-icon-bubble after any successful cart change.
   ------------------------------------------------------------------ */
(function () {
  if (!window.fetch || window.__chgCartBubblePatched) return;
  window.__chgCartBubblePatched = true;
  var originalFetch = window.fetch;

  function refreshBubble() {
    originalFetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('#cart-icon-bubble').forEach(function (icon) {
          var bubble = icon.querySelector('.cart-count-bubble');
          if (!cart.item_count) {
            if (bubble) bubble.remove();
            return;
          }
          if (!bubble) {
            bubble = document.createElement('div');
            bubble.className = 'cart-count-bubble';
            icon.appendChild(bubble);
          }
          bubble.innerHTML =
            (cart.item_count < 100 ? '<span aria-hidden="true">' + cart.item_count + '</span>' : '') +
            '<span class="visually-hidden">' + cart.item_count + ' items</span>';
        });
      })
      .catch(function () {});
  }

  window.fetch = function (resource, init) {
    var url = typeof resource === 'string' ? resource : (resource && resource.url) || '';
    var p = originalFetch.apply(this, arguments);
    if (/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url)) {
      p.then(function (res) { if (res && res.ok) refreshBubble(); }).catch(function () {});
    }
    return p;
  };
})();
